export const decisioningStudioAgentsAppGroupIdDsaIdSegments =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/audiences/segments";

export const decisioningStudioAgentsAppGroupIdDsaIdSegmentsCacheKeys =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/audiences/segments";
